import { NotificationCard } from '../../components/Card';
import { ScoreCardContainer } from './ScorecardContainer';

export const FillScoreCard = ({ notification = {}, onClose = () => {} }) => {
  return (
    <NotificationCard notification={notification}>
      <ScoreCardContainer
        notification={notification}
        onClose={onClose}
        type="fill"
      />
    </NotificationCard>
  );
};

export const ReviewScoreCard = ({ notification = {}, onClose = () => {} }) => {
  return (
    <NotificationCard notification={notification}>
      <ScoreCardContainer
        notification={notification}
        onClose={onClose}
        type="review"
      />
    </NotificationCard>
  );
};
